import { render, staticRenderFns } from "./Step0.vue?vue&type=template&id=1ffa05a4&lang=pug&"
import script from "./Step0.vue?vue&type=script&lang=js&"
export * from "./Step0.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports